// Функция копирования текста
export function copytext(el) {
    const $tmp = $('<textarea>');

    $('body').append($tmp);
    $tmp.val($(el).text()).select();
    document.execCommand('copy');
    $tmp.remove();
}